import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "ee_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-50 bg-[#111827] text-white border border-white/10 shadow-2xl rounded-sm p-6"
    >
      <div className="flex items-start gap-3">
        <Cookie size={22} className="text-espana-gold shrink-0 mt-0.5" />
        <div>
          <h3 className="font-bold">Uso de cookies</h3>
          <p className="mt-1 text-sm text-white/70 leading-relaxed">
            Usamos cookies técnicas y, con tu permiso, analíticas para mejorar la
            web. Consulta la{" "}
            <Link to="/cookies" className="text-espana-gold underline">
              Política de Cookies
            </Link>
            .
          </p>
          <div className="mt-4 flex gap-2">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("accepted")}
              className="bg-espana-red hover:bg-espana-reddark text-white text-sm font-bold px-4 py-2 rounded-sm transition-colors"
            >
              Aceptar
            </button>
            <button
              data-testid="cookie-reject"
              onClick={() => decide("rejected")}
              className="border border-white/25 hover:bg-white/10 text-white text-sm font-bold px-4 py-2 rounded-sm transition-colors"
            >
              Solo técnicas
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
